import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const SearchBoxContainer = styled.div`
    display: flex;
    margin-left: 16px;
    height: 40px;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    text-align: left;
    color: ${({ color }) => (color ? color : '#767676')};
    align-items: center;
    background: ${({ background }) =>
        background ? background : '#FFFFFF 0% 0% no-repeat padding-box'};
    border: ${({ border }) => (border ? border : ' 2px solid #EBEDED')};
    border-radius: ${({ borderRadius }) =>
        borderRadius ? borderRadius : '20px'};

    width: ${({ width }) => (width ? width : '20%')};

    ${media.mediumDevice`
       
    `}

    ${media.smalDevice`
        
    `}

    ${media.mobileDevice`
        width: ${({ mobileWidth }) => (mobileWidth ? mobileWidth : '100%')};
        height: ${({ mobileHeight }) => (mobileHeight ? mobileHeight : '40px')};
        border-radius: 20px;
        margin: 10px 0 5px 0;                  
    `};
`;

export const StyledInput = styled.input`
    margin: 0 1.5rem 0 0;
    outline: none;
    border: none;
    width: ${({ width }) => (width ? width : '80%')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    color: ${({ color }) => (color ? color : '#767676')};
    border-radius: ${({ borderRadius }) =>
        borderRadius ? borderRadius : '20px'};
    display: flex;
    justify-content: flex-start;
    align-items: center;
    opacity: 0.7;
    ::-ms-input-placeholder {
        /* Microsoft Edge */
        color: #767676;
        font-family: 'AvenirNextWorld Regular';
    }
    ::placeholder {
        /* Firefox */
        color: #767676;
        font-family: 'AvenirNextWorld Regular';
    }
    :-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #767676;
        font-family: 'AvenirNextWorld Regular';
    }
    ::-webkit-input-placeholder {
        /* Safari */
        color: #767676;
        font-family: 'AvenirNextWorld Regular';
    }

    ${media.mediumDevice`
        margin:0;
        padding-left: 3px;
        font-size: 13px;
    `}

    ${media.smalDevice`
        width: 100%;
        ::-ms-input-placeholder {
            /* Microsoft Edge */
            color: #767676;
            font-family: 'AvenirNextWorld Regular';
        }
        ::placeholder {
            /* Firefox */
            color: #767676;
            font-family: 'AvenirNextWorld Regular';
        }
        :-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: #767676;
            font-family: 'AvenirNextWorld Regular';
        }
        ::-webkit-input-placeholder {
            /* Safari */
            color: #767676;
            font-family: 'AvenirNextWorld Regular';
        }
    `}

    ${media.mobileDevice`
        opacity: 1;
         font-size: 14px;
    `}
`;
export const IconContainer = styled.div`
    width: ${({ width }) => (width ? width : '30px')};
    height: ${({ height }) => (height ? height : '20px')};
    opacity: 0.7;
    margin: 0 0 0 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    ${media.smalDevice`
        width:  20px;
        height: : 20px;
        margin: 0 0 0 5px;
    `}

    ${media.mobileDevice`
        width: ${({ mobileWidth }) => (mobileWidth ? mobileWidth : '30px')};
        height: ${({ mobileHeight }) => (mobileHeight ? mobileHeight : '20px')};
        opacity:1;
        margin: 0 0 0 10px;
    `}
`;

export const ClearIconContainer = styled.div`
    margin: 0px 7.5px;
    opacity: 0.7;
    width: ${({ width }) => (width ? width : '30px')};
    height: ${({ height }) => (height ? height : '26px')};
    cursor: ${({ cursor }) => (cursor ? cursor : ' ')};
`;

export const Icon = styled.div`
    background: url(${(props) => props.deskPath});
    height: 2.7rem;
    width: 2.7rem;
    cursor: pointer;
    background-repeat: no-repeat;
    position: relative;
    margin-right: ${(props) =>
        props.marginRightDesktop ? props.marginRightDesktop : '0px'};
    ${media.mobileDevice`
        background: url(${(props) => props.mobilePath});
        background-repeat: no-repeat;
        margin-right: ${(props) =>
            props.marginRightMobile ? props.marginRightMobile : '0px'};
        bottom: ${(props) => props.bottom};
    `}
`;

export const SearchWarning = styled.div`
    color: #ed002a;
    font-size: 13px;
    font-family: 'AvenirNextWorld Regular';
    padding-left: 30px;
    ${media.mobileDevice`
padding-left: 20px;
`}
`;
